export const COLOR_THEMES = {
  DARK: 'darkConfig',
  LIGHT: 'lightConfig',
};

export const DEVICE_THEMES = {
  WEBSITE: 'website',
  EXTENSION: 'extension',
};
